import Cookies from "js-cookie";
import { routes } from "./routes";
import { formatProductPrice } from "./helpers/formatting";
import {
  excludedQueryParams,
  getOptionIdByLabel,
} from "../services/productList";

export const getListingPayload = ({
  initial,
  sortOpt,
  skuList,
  isManual,
  cookieKeys,
  queryParam,
  componentId,
  showSpecific,
  specialCoupon,
  currentVehicle,
  manualSessionId,
}) => {
  let data = {
    continueFetch: true,
    manualLookUp: isManual,
    payload: {
      sortOpt,
      specialCoupon,
      currentVehicle,
      skuList: null,
      vFilter: null,
      sessionInfo: null,
    },
  };

  const isServer = typeof window === "undefined";
  if (!isServer) {
    const sParams = new URLSearchParams(window.location.search);
    if (sParams.has("auto_apply_coupon")) {
      data.payload.specialCoupon = sParams.get("auto_apply_coupon");
    } else {
      data.payload.specialCoupon =
        Cookies.get(cookieKeys.specialCoupon) || null;
    }
  }

  const updateSessionInfo = () => {
    data.payload.sessionInfo = currentVehicle?.session;
    data.manualLookUp = queryParam.has("make") && queryParam.has("model");
    if (!data.payload.sessionInfo && data.manualLookUp && manualSessionId) {
      data.payload.sessionInfo = { sessionId: manualSessionId };
    }
  };

  if (initial.is3BO) {
    if (showSpecific) updateSessionInfo();
  } else if (initial.isCarParts) {
    updateSessionInfo();
  }

  if (!componentId && data.payload.sessionInfo) {
    data.continueFetch = false;
  }

  if (data.continueFetch && data.payload.sessionInfo) {
    data.payload = {
      ...data.payload,
      skuList: isManual ? [] : skuList,
      vFilter: {
        component_id: componentId,
        vrm: currentVehicle?.vehicle?.vrm || "",
        make: currentVehicle?.vehicle?.make || "",
        model: currentVehicle?.vehicle?.model || "",
        session_id: data.payload.sessionInfo?.sessionId,
        year:
          (currentVehicle.vehicle?.modelVersion?.match(/\(([^)]+)\)/) ||
            [])[1] ||
          currentVehicle.vehicle?.dateOfManufacture?.match(/^(\d{4})/)[0] ||
          "",
        engine: currentVehicle?.vehicle?.engineSize || "",
        body: currentVehicle?.vehicle?.bodyStyle || "",
        hp: currentVehicle?.vehicle?.power || "",
      },
    };
  }
  return data;
};

export const updateURLParams = ({
  page,
  params,
  isManual,
  pushState,
  resetBrand,
  hasVehicle,
  replaceHistory,
  selectedFilters,
}) => {
  let queries = {};
  excludedQueryParams.forEach((param) => {
    if (params?.get(param)) {
      queries[param] = params?.get(param);
    }
  });

  queries["page"] = page;
  if (isManual && !hasVehicle) {
    queries["make"] = params?.get("make");
    queries["model"] = params?.get("model");
  }

  if (queries.page == 1) delete queries.page;
  if (!resetBrand && params?.has("brand")) {
    queries["brand"] = params?.get("brand");
  }

  const isServer = typeof window === "undefined";
  if (pushState && !isServer) {
    const queryStr = new URLSearchParams(queries).toString();
    const historyURL = location.pathname + (queryStr ? `?${queryStr}` : "");
    if (replaceHistory || resetBrand) {
      window.history.replaceState(null, "", historyURL);
    } else {
      window.history.pushState(null, "", historyURL);
    }
  }

  let filtersObj = {};
  selectedFilters.forEach((filter) => {
    if (!filtersObj[filter.code]) filtersObj[filter.code] = [];
    filtersObj[filter.code].push(filter.value);
  });
  return filtersObj;
};

export const getStoredBranch = (storageKey) => {
  const isServer = typeof window === "undefined";
  if (isServer) return {};
  try {
    const jsonStr = localStorage.getItem(storageKey);
    if (jsonStr) {
      const storeBranch = JSON.parse(jsonStr);
      return storeBranch || {};
    }
  } catch (err) {
    console.error(err);
  }
  return {};
};

export const getEncodedQueryString = (queryParams = {}) => {
  let queryString = "";
  const firstIndex = Object.keys(queryParams)?.at(0);
  for (const key in queryParams) {
    if (queryParams.hasOwnProperty(key)) {
      const value = encodeURIComponent(queryParams[key])?.replace(/%20/g, "+");
      if (key !== firstIndex) {
        queryString += `&`;
      }
      queryString += `${key}=${value}`;
    }
  }
  return queryString;
};

export const getRedirectURL = (data, searchTerm, onResultPage = false) => {
  const totalProducts = data?.products?.total_count || 0;
  const totalCategories = data?.products?.category_count || 0;
  let redirectURL = "";

  if (data?.products?.search_trems) {
    const searchTerms = data.products.search_trems;
    const redirect = searchTerms[0]?.redirect;
    redirectURL = redirect;
  }

  if (!redirectURL) {
    if (
      totalProducts === 1 &&
      !totalCategories &&
      data?.products?.items?.length > 0
    ) {
      const result = data.products.items[0];
      redirectURL = `${routes.products}/${result.url_key}`;
    }

    if (
      totalCategories === 1 &&
      !totalProducts &&
      data?.products?.categories?.length > 0
    ) {
      const result = data.products.categories[0];
      redirectURL = `/${result.link}`;
    }

    if (!onResultPage && !redirectURL) {
      const queryString = getEncodedQueryString({ q: searchTerm });
      redirectURL = `${routes.searchResults}?${queryString}`;
    }
  }

  return { totalProducts, totalCategories, redirectURL };
};

export const mapItemStocks = (itemArr, branch, field = "brands") => {
  const findStock = (itemSku, stockKey) => {
    return branch[stockKey]?.find((i) => i.sku === itemSku);
  };
  return itemArr.map((item) => {
    const group = item[field].map((fieldItem) => {
      const itemObj =
        field === "items" ? { ...fieldItem, branch } : { ...fieldItem };

      const ndcStock = findStock(itemObj.sku, "ndc");
      const hubStock = findStock(itemObj.sku, "hub");
      const branchStock = findStock(itemObj.sku, "products");
      return {
        ...itemObj,
        hub_stock: hubStock ? hubStock?.stock_qty || 0 : 0,
        ndc_stock: ndcStock ? ndcStock?.stock_qty || 0 : 0,
        branch_stock: branchStock ? branchStock?.stock_qty || 0 : 0,
      };
    });
    return { ...item, branch, [field]: group };
  });
};

export const updateFitmentInfo = (sku, items, fitment, field = "brands") => {
  return items.map((p) => {
    return {
      ...p,
      brands: p[field]?.map((b) => {
        if (b.sku === sku) {
          b.fitment_info = fitment;
        }
        return b;
      }),
    };
  });
};

export const formatEngineOilProducts = (products, metaData, icons = {}) => {
  const selectedBranch = metaData?.selectedBranch || {};
  const getSizeInNumber = (str = "") => {
    if (!str) return null;
    const number = str.replace(/\D/g, "");
    return number ? Number(number) : null;
  };

  return products.map((p) => {
    const { brand_group = [], extraVariable, ...rest } = p;
    const brand = extraVariable?.brand_info || {};
    const breadcrumbs = extraVariable?.breadcrumbs || [];
    const groupItems = [
      { ...rest, size: p?.size_label || null },
      ...brand_group,
    ].map((item) => {
      const isArray = item?.thumbnail ? Array.isArray(item.thumbnail) : false;
      return {
        ...item,
        thumbnail: isArray ? item.thumbnail[0] : item.thumbnail,
      };
    });

    // Sort items by size
    groupItems.sort((a, b) => {
      return getSizeInNumber(a.size) - getSizeInNumber(b.size);
    });

    // Selecting the first item with a valid size as the default option
    const defaultItem = groupItems.find((i) => i.size);
    const formattedGroupItems = groupItems.map((b) => {
      const meta = metaData[b.sku] || {
        review: null,
        hub_stock: 0,
        ndc_stock: 0,
        branch_stock: 0,
        query_text: "",
      };

      const min = b?.price_range?.minimum_price || {};
      const final = min?.final_price || {};
      const regular = min?.regular_price || {};
      const amountOff = min?.discount?.amount_off || 0;
      const percentOff = min?.discount?.percent_off || 0;
      const quantity = b.qty || 0;

      return {
        ...b,
        breadcrumbs,
        fitment_info: [],
        product_id: b.id,
        product_uid: b.uid,
        base_title: b.name,
        review: meta.review,
        qty: Number(quantity),
        branch: selectedBranch,
        hub_stock: meta.hub_stock,
        ndc_stock: meta.ndc_stock,
        quantity: Number(quantity),
        query_text: meta.query_text,
        thumbnail: b.thumbnail || {},
        surcharge: b.surcharge || null,
        special_price: b.special_price,
        branch_stock: meta.branch_stock,
        best_seller: b.best_seller || 0,
        currency: final?.currency || "",
        is_recommended: b.is_recommended,
        showDiscountedPrice: amountOff >= 5,
        productOffer: b.promo_offer || null,
        sold_in_pairs: b.sold_in_pairs || 0,
        amountOff_without_currency: amountOff,
        final_price: formatProductPrice(final),
        bestseller_img: icons?.bestseller || "",
        special_to_date: b.special_to_date || "",
        recommended_img: icons?.recommended || "",
        regular_price: formatProductPrice(regular),
        final_price_without_currency: final?.value,
        special_from_date: b.special_from_date || "",
        regular_price_without_currency: regular?.value,
        specialCoupon_applied: b.specialCoupon_applied ?? true,
        stop_start_compatible: b.stop_start_compatible || null,
        percent_off: percentOff > 9 ? `${percentOff}` : `0${percentOff}`,
        warranty_guaranteed_text: b.warranty_guaranteed_text || null,
        amountOff: formatProductPrice({
          ...regular,
          value: amountOff,
        }),
        showStrikePrice: final?.value < regular?.value || !!b.special_price,
        title_with_brand: `${
          brand?.title ? brand.title.toUpperCase() + " - " : ""
        }${b.name}`,
      };
    });

    return {
      brand,
      breadcrumbs,
      art_nr: p.art_nr,
      branch: selectedBranch,
      items: formattedGroupItems,
      selected: defaultItem?.id || groupItems[0].id,
    };
  });
};

export const getSelectedCat = ({
  catId,
  componentId,
  additional,
  initialCat = null,
}) => {
  const catIdArr = [catId];
  const compIdArr = [componentId];

  if (initialCat) {
    if (additional.length === 1) {
      if (!catIdArr.includes(catId)) catIdArr.push(catId);
      if (!compIdArr.includes(componentId)) compIdArr.push(componentId);
      initialCat.forEach((ele) => {
        if (ele?.id) catIdArr.push(ele.id);
        if (ele?.component_id) compIdArr.push(ele.component_id);
      });
    } else {
      additional.forEach((ele) => {
        if (ele?.id && !catIdArr.includes(ele.id)) catIdArr.push(ele.id);
        if (ele?.component_id && !compIdArr.includes(ele.component_id))
          compIdArr.push(ele.component_id);
      });
    }
  }

  return { catIdArr, compIdArr };
};

export const canStopFetching = ({
  is3BO,
  isManual,
  isCarParts,
  componentId,
  showSpecific,
  hasNoVehicle,
}) => {
  let canStopProcess = false;
  if (is3BO) {
    if (showSpecific.current) {
      canStopProcess = !componentId;
      if (!canStopProcess && hasNoVehicle) {
        canStopProcess = isManual.current;
      }
    }
  } else if (isCarParts) {
    canStopProcess = isManual.current || hasNoVehicle;
  }
  return canStopProcess;
};

export const getBrandFilter = async ({ brand, filterOptions }) => {
  let brandOpt = { filter_label: "Brand", code: "quality" };
  const brandItem = filterOptions.find(
    (o) => o.label.toLowerCase() === "brand",
  );

  if (brandItem) {
    const brandInfo = brandItem.options.find(
      (o) => o.label.toLowerCase() === brand.toLowerCase(),
    );
    brandOpt = brandInfo ? { ...brandOpt, ...brandInfo } : brandOpt;
  }

  if (!brandOpt?.value) {
    const { data } = await getOptionIdByLabel(brand);
    brandOpt = {
      ...brandOpt,
      count: 1,
      label: brand,
      value: data?.getOptionIdByLabel?.option_id?.toString(),
    };
  }
  return brandOpt;
};

export const getSKUList = (items, skuList, hasVehicle, brandGroup = false) => {
  const itemSku = [];
  const vrmSkuList = [];
  const addToNewSkuList = (sku) => {
    if (hasVehicle && !skuList.includes(sku)) {
      vrmSkuList.push(sku);
    }
  };

  items.forEach((item) => {
    itemSku.push(item.sku);
    addToNewSkuList(item.sku);
    if (brandGroup) {
      item.brand_group.forEach((p) => {
        itemSku.push(p.sku);
        addToNewSkuList(p.sku);
      });
    }
  });

  return { itemSku, vrmSkuList };
};
